<template>
    <Dashboard
        :title="__('Pages', null, $page.props.profile_locale)"
    >
        <Heading
            :label="__('Pages', null, $page.props.profile_locale)"
        />
        <div class="overflow-auto w-full shadow-md rounded-md">
        <table class="w-full whitespace-nowrap">
            <thead class="relative">
                <tr
                    class="text-xs font-semibold tracking-wide text-left text-gray-200 uppercase border-b bg-gray-900 border-red-700"
                >
                    <th class="px-4 py-3">{{__('Title', null, $page.props.profile_locale)}}</th>
                    <th class="px-4 py-3">{{__('Actions', null, $page.props.profile_locale)}}</th>
                </tr>
            </thead>
            <tbody class="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800">
                <tr
                    v-for="page in pages"
                    :key="page.id"
                    class="bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-900 text-gray-700 dark:text-gray-400"
                >
                    <td class="px-4 py-1 font-bold">
                        {{ (page.slug == 'lottery' ? __('Lottery') : page.title) }}
                    </td>
                    <td class="px-4 py-1 text-sm flex">
                        <IconLink
                            color="gray"
                            icon="pencil"
                            class="p-1 mr-1"
                            :href="route('dashboard.pages.edit', page.slug)"
                        ></IconLink>
                    </td>
                </tr>
            </tbody>
        </table>
        </div>
        <!-- <PaginateLink
            class="mt-5"
            :links="products.links"
        /> -->
    </Dashboard>
</template>

<script>
    import Dashboard from '@/Layouts/Dashboard';
    import IconLink from 'UI/IconLink';
    import Heading from 'COMP/Heading';
    import Button from 'UI/Button';
    import SvgIcon from 'UI/SvgIcon';
    import InputLabel from 'UI/InputLabel';
    import { useForm } from '@inertiajs/inertia-vue3'


    export default {
        props: {
            pages: [Array, Object],
        },
        components: {
            Dashboard,
            Button,
            SvgIcon,
            InputLabel,
            Heading,
            IconLink
        },
        setup(props) {

            const form = useForm(props.options)

            function save(){

            }

            return {
                form,
                save,
            }
        },

    }
</script>
